// extracted by mini-css-extract-plugin
export default {"conditionTagify":"conditionTagify__ZBJVD","explanationText":"explanationText__4blnF"};